import {
  SimpleForm,
  Edit,
  TextInput,
  useRecordContext,
  Toolbar,
  SaveButton,
  ReferenceInput,
  AutocompleteInput,
  regex,
  required,
} from "react-admin";
// import { CustomArray } from "./CustomArray";
import { settings } from "app";
import ImageItem from "./ImageItem";

const EditInner = ({ sizesToRemove }) => {
  const record = useRecordContext();

  const sizes = ["default", "sm", "md", "lg", "xl", "2xl"];

  return sizes.map(size => {
    const image = record.files?.find(image => image === size);

    return (
      <ImageItem
        key={size}
        source={size}
        label={size}
        src={image ? `${settings.cmsApi}/media?Name=${record.name}&Size=${size}&v=${new Date().getTime()}` : ""}
        sizesToRemove={sizesToRemove}
      />
    );
  });
};

const CustomToolbar = () => (
  <Toolbar>
    <SaveButton alwaysEnable={true} />
  </Toolbar>
);

export const EditGallery = () => {
  const record = useRecordContext();

  const sizesToRemove = [];

  return (
    <Edit
      title="Редактиране на медия файл"
      mutationMode="pessimistic"
      mutationOptions={{ meta: { useFormData: true, params: { sizes_to_remove: sizesToRemove } } }}
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput
          validate={[required(), regex(/^[A-Za-z0-9-_]+$/, "Името трябва да съдържа само букви, цифри и тирета!")]}
          source="name"
          label="Име (без спейсове)"
        />
        <ReferenceInput
          reference={"applications-cms"}
          source="applicationId"
          queryOptions={{ meta: { mixed_provider: true } }}
        >
          <AutocompleteInput
            label="Application"
            filterToQuery={q => ({ Name: q })}
            optionText={"name"}
            fullWidth
          />
        </ReferenceInput>
        <EditInner sizesToRemove={sizesToRemove} />
      </SimpleForm>
    </Edit>
  );
};

export default EditGallery;
